module.exports = __webpack_public_path__ + "static/media/ogi.7cba4321.png";